<div class="card">
  <div class="card-body">
    <mat-spinner *ngIf="loading" [diameter]="20"></mat-spinner>
    <div class="text-end"><a routerLink="/" i18n>Home</a></div>
    <div class="p-0" *ngIf="!loading">
      <p class="small d-none d-md-block" *ngFor="let z of obsah" [innerHTML]="z.obsah"></p>
      <p class="small d-block d-md-none" *ngFor="let z of obsahMobil" [innerHTML]="z.obsah"></p>
    </div>
  </div>
</div>
